export const DEFAULT_CONTACTLESS_IMG = "/assets/brand.png";
export const USA_FLAG_CONTACTLESS_IMG = "/assets/usa_flag_icon.png";
export const TEST_QR_CODE_ICON = "/assets/qr_code_test_icon.svg";

export const CONTACTLESS_SELLING_POINT =
  "Contactless payments and their usage is expected to triple by 2024. PriceBlocs helps your business adapt with customizable, payment QR codes.";

export const CONTACTLESS_HIGHLGHTS = [
  {
    title: "One scan checkout",
    body:
      "Scan any PriceBlocs QR code with a smartphone and go directly to checkout."
  },
  {
    title: "Custom branding",
    body:
      "Customize any code with your brand logo and colors, to make it distinctively yours."
  },
  {
    title: "Use anywhere",
    id: "contactless-content",
    body: "Download your QR codes and use them anywhere your customers are."
  }
];

const PRODUCT = "product";
const CODE = "code";

export const CONTACTLESS_PREVIEW_MODE = {
  PRODUCT,
  CODE
};

export const DOT_OPTION = {
  uid: "dot",
  label: "Dot"
};
export const SQUARE_OPTION = {
  uid: "square",
  label: "Square"
};
export const BUBBLE_OPTION = {
  uid: "extra-rounded",
  label: "Bubble"
};
export const ROUNDED_OPTION = {
  uid: "rounded",
  label: "Rounded"
};
export const DOTS_OPTION = {
  uid: "dots",
  label: "Dots"
};
export const CLASSY_OPTION = {
  uid: "classy",
  label: "Angled"
};
export const CLASSY_ROUNDED_OPTION = {
  uid: "classy-rounded",
  label: "Rounded angles"
};
export const DOTS_OPTIONS_TYPE = [
  ROUNDED_OPTION,
  DOTS_OPTION,
  CLASSY_OPTION,
  CLASSY_ROUNDED_OPTION,
  SQUARE_OPTION,
  BUBBLE_OPTION
];

export const CORNERS_SQUARE_OPTIONS_TYPE = [
  DOT_OPTION,
  SQUARE_OPTION,
  BUBBLE_OPTION
];

export const CORNERS_DOT_OPTIONS_TYPE = [DOT_OPTION, SQUARE_OPTION];

export const QR_CODE_STATE_KEYS = {
  DOT_OPTIONS_COLOR: "dotsOptions.color",
  DOT_OPTIONS_TYPE: "dotsOptions.type",
  CORNERS_SQUARE_OPTIONS_COLOR: "cornersSquareOptions.color",
  CORNERS_SQUARE_OPTIONS_TYPE: "cornersSquareOptions.type",
  CORNERS_DOT_OPTIONS_COLOR: "cornersDotOptions.color",
  CORNERS_DOT_OPTIONS_TYPE: "cornersDotOptions.type",
  BACKGROUND_OPTIONS_COLOR: "backgroundOptions.color"
};

export const CONTACTLESS_OPTIONS = {
  DOTS_OPTIONS_TYPE,
  CORNERS_SQUARE_OPTIONS_TYPE,
  CORNERS_DOT_OPTIONS_TYPE
};
